import { useEffect, useState } from "react";
import { fetchAcademies, createAcademy } from "@/api/academies";

export default function Academies() {
  const [academies, setAcademies] = useState([]);
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    address: "",
    description: "",
    password: "",
    image: null,
  });
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  // جلب الأكاديميات
  const loadAcademies = async () => {
    try {
      const data = await fetchAcademies();
      setAcademies(data);
    } catch (err) {
      console.error(err);
      setError("فشل تحميل الأكاديميات");
    }
  };

  useEffect(() => {
    loadAcademies();
  }, []);

  // إنشاء أكاديمية
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await createAcademy(form);

      setForm({
        name: "",
        phone: "",
        email: "",
        address: "",
        description: "",
        password: "",
        image: null,
      });
      setPreview(null);

      loadAcademies();
    } catch (err) {
      setError("فشل إنشاء الأكاديمية");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // تصفية الأكاديميات حسب البحث
  const filteredAcademies = academies.filter(academy => {
    if (!searchTerm) return true;
    const term = searchTerm.toLowerCase();
    return (
      (academy.name || "").toLowerCase().includes(term) ||
      (academy.email || "").toLowerCase().includes(term) ||
      (academy.phone || "").toLowerCase().includes(term) ||
      (academy.address || "").toLowerCase().includes(term)
    );
  });

  return (
    <div className="academies-container">
      {/* رأس الصفحة */}
      <div className="academies-header">
        <h1 className="page-title">إدارة الأكاديميات</h1>
        <p className="page-subtitle">أنشئ وعُدّل على الأكاديميات التعليمية</p>
      </div>

      {/* قسم النموذج */}
      <div className="form-section">
        <div className="section-header">
          <h2 className="section-title">إضافة أكاديمية جديدة</h2>
          <p className="section-description">املأ البيانات لإنشاء أكاديمية جديدة</p>
        </div>

        <form onSubmit={handleSubmit} encType="multipart/form-data" className="academy-form">
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">
                اسم الأكاديمية
                <span className="required">*</span>
              </label>
              <input
                className="form-input"
                placeholder="أدخل اسم الأكاديمية"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">
                البريد الإلكتروني
                <span className="required">*</span>
              </label>
              <input
                className="form-input"
                type="email"
                placeholder="example@academy.com"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="form-label">
                رقم الهاتف
                <span className="required">*</span>
              </label>
              <input
                className="form-input"
                placeholder="+966 5X XXX XXXX"
                value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">
                كلمة المرور
                <span className="required">*</span>
              </label>
              <input
                className="form-input"
                type="password"
                placeholder="أدخل كلمة مرور قوية"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                required
                minLength={6}
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">العنوان</label>
            <input
              className="form-input"
              placeholder="المدينة، الحي، الشارع"
              value={form.address}
              onChange={(e) => setForm({ ...form, address: e.target.value })}
            />
          </div>

          <div className="form-group">
            <label className="form-label">الوصف</label>
            <textarea
              className="form-textarea"
              placeholder="صف مختصر عن الأكاديمية ونشاطاتها..."
              value={form.description}
              onChange={(e) => setForm({ ...form, description: e.target.value })}
              rows={4}
            />
          </div>

          {/* رفع الصورة */}
          <div className="form-group">
            <label className="form-label">صورة الشعار</label>
            <div className="image-upload-container">
              <div className="image-upload-area">
                <input
                  type="file"
                  accept="image/*"
                  className="file-input"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    setForm({ ...form, image: file });
                    setPreview(file ? URL.createObjectURL(file) : null);
                  }}
                  id="image-upload"
                />
                <label htmlFor="image-upload" className="upload-label">
                  <div className="upload-content">
                    <svg className="upload-icon" viewBox="0 0 24 24" fill="none">
                      <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M17 8L12 3L7 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M12 3V15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <p className="upload-text">اسحب وأفلت الصورة هنا أو انقر للاختيار</p>
                    <p className="upload-hint">JPG, PNG, GIF - الحد الأقصى 5MB</p>
                  </div>
                </label>
              </div>

              {preview && (
                <div className="image-preview">
                  <div className="preview-header">
                    <span className="preview-title">معاينة الصورة</span>
                    <button 
                      type="button" 
                      className="remove-preview"
                      onClick={() => {
                        setForm({ ...form, image: null });
                        setPreview(null);
                      }}
                    >
                      ×
                    </button>
                  </div>
                  <img
                    src={preview}
                    alt="معاينة"
                    className="preview-image"
                  />
                </div>
              )}
            </div>
          </div>

          <div className="form-actions">
            <button 
              type="submit" 
              className="submit-button"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="button-spinner"></span>
                  جاري الإنشاء...
                </>
              ) : "إنشاء أكاديمية"}
            </button>
          </div>

          {error && (
            <div className="error-message">
              <svg className="error-icon" viewBox="0 0 24 24" fill="none">
                <path d="M12 8V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <path d="M12 16H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
              <span>{error}</span>
            </div>
          )}
        </form>
      </div>

      {/* قسم قائمة الأكاديميات */}
      <div className="list-section">
        <div className="section-header">
          <div className="header-content">
            <h2 className="section-title">قائمة الأكاديميات</h2>
            <p className="section-description">عرض جميع الأكاديميات المسجلة</p>
          </div>
          
          <div className="search-box">
            <svg className="search-icon" viewBox="0 0 24 24" fill="none">
              <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <path d="M21 21L16.65 16.65" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            <input
              type="text"
              className="search-input"
              placeholder="ابحث عن أكاديمية..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {searchTerm && (
              <button 
                className="clear-search"
                onClick={() => setSearchTerm("")}
              >
                ×
              </button>
            )}
          </div>
        </div>

        <div className="stats-bar">
          <div className="stat-item">
            <span className="stat-number">{academies.length}</span>
            <span className="stat-label">إجمالي الأكاديميات</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">{filteredAcademies.length}</span>
            <span className="stat-label">تم العثور عليها</span>
          </div>
        </div>

        {filteredAcademies.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">🏫</div>
            <h3 className="empty-title">
              {searchTerm ? "لا توجد أكاديميات تطابق البحث" : "لا توجد أكاديميات مسجلة"}
            </h3>
            <p className="empty-description">
              {searchTerm ? "جرب مصطلحات بحث مختلفة" : "ابدأ بإضافة أول أكاديمية"}
            </p>
          </div>
        ) : (
          <div className="academies-grid">
            {filteredAcademies.map((academy) => (
              <div key={academy.id} className="academy-card">
                <div className="card-header">
                  <div className="academy-avatar">
                    {academy.image_url ? (
                      <img 
                        src={academy.image_url} 
                        alt={academy.name}
                        className="avatar-image"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextElementSibling.style.display = 'flex';
                        }}
                      />
                    ) : (
                      <div className="avatar-placeholder">
                        {academy.name.charAt(0)}
                      </div>
                    )}
                  </div>
                  <div className="academy-info">
                    <h3 className="academy-name">{academy.name}</h3>
                    <p className="academy-email">{academy.email}</p>
                  </div>
                </div>

                <div className="card-body">
                  <div className="contact-info">
                    <div className="contact-item">
                      <svg className="contact-icon" viewBox="0 0 24 24" fill="none">
                        <path d="M22 16.92V19C22 19.5304 21.7893 20.0391 21.4142 20.4142C21.0391 20.7893 20.5304 21 20 21H4C3.46957 21 2.96086 20.7893 2.58579 20.4142C2.21071 20.0391 2 19.5304 2 19V16.92" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        <path d="M18 12L12 6L6 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M12 6V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                      <span className="contact-text">{academy.email}</span>
                    </div>
                    <div className="contact-item">
                      <svg className="contact-icon" viewBox="0 0 24 24" fill="none">
                        <path d="M22 16.92V19C22 19.5304 21.7893 20.0391 21.4142 20.4142C21.0391 20.7893 20.5304 21 20 21H4C3.46957 21 2.96086 20.7893 2.58579 20.4142C2.21071 20.0391 2 19.5304 2 19V16.92" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        <path d="M18 12L12 6L6 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M12 6V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                      <span className="contact-text">{academy.phone || "غير متوفر"}</span>
                    </div>
                    {academy.address && (
                      <div className="contact-item">
                        <svg className="contact-icon" viewBox="0 0 24 24" fill="none">
                          <path d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                          <path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                        <span className="contact-text">{academy.address}</span>
                      </div>
                    )}
                  </div>

                  {academy.description && (
                    <div className="description-box">
                      <p className="description-text">{academy.description}</p>
                    </div>
                  )}
                </div>

                <div className="card-footer">
                  <div className="academy-id">
                    <span className="id-label">ID:</span>
                    <span className="id-value">{academy.id}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <style jsx>{`
        .academies-container {
          padding: 2rem;
          max-width: 1200px;
          margin: 0 auto;
          background: #f8fafc;
          min-height: 100vh;
        }

        .academies-header {
          margin-bottom: 3rem;
          text-align: center;
        }

        .page-title {
          font-size: 2.5rem;
          color: #1e293b;
          margin-bottom: 0.5rem;
          font-weight: 700;
          background: linear-gradient(135deg, #3b82f6, #1d4ed8);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .page-subtitle {
          color: #64748b;
          font-size: 1.125rem;
          max-width: 600px;
          margin: 0 auto;
          line-height: 1.6;
        }

        .form-section {
          background: white;
          border-radius: 16px;
          padding: 2.5rem;
          margin-bottom: 3rem;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          border: 1px solid #e2e8f0;
        }

        .section-header {
          margin-bottom: 2rem;
        }

        .section-title {
          font-size: 1.5rem;
          color: #1e293b;
          margin-bottom: 0.5rem;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }

        .section-title::before {
          content: '';
          width: 4px;
          height: 24px;
          background: #3b82f6;
          border-radius: 2px;
        }

        .section-description {
          color: #64748b;
          font-size: 0.95rem;
          margin: 0;
        }

        .academy-form {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .form-row {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 1.5rem;
        }

        @media (max-width: 768px) {
          .form-row {
            grid-template-columns: 1fr;
          }
        }

        .form-group {
          display: flex;
          flex-direction: column;
        }

        .form-label {
          color: #334155;
          font-weight: 600;
          margin-bottom: 0.5rem;
          font-size: 0.95rem;
          display: flex;
          align-items: center;
          gap: 0.25rem;
        }

        .required {
          color: #ef4444;
        }

        .form-input {
          padding: 0.875rem 1rem;
          border: 2px solid #e2e8f0;
          border-radius: 10px;
          font-size: 1rem;
          transition: all 0.3s ease;
          background: #f8fafc;
          color: #334155;
        }

        .form-input:focus {
          outline: none;
          border-color: #3b82f6;
          background: white;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }

        .form-input::placeholder {
          color: #94a3b8;
        }

        .form-textarea {
          padding: 1rem;
          border: 2px solid #e2e8f0;
          border-radius: 10px;
          font-size: 1rem;
          transition: all 0.3s ease;
          background: #f8fafc;
          color: #334155;
          resize: vertical;
          min-height: 100px;
          font-family: inherit;
        }

        .form-textarea:focus {
          outline: none;
          border-color: #3b82f6;
          background: white;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }

        .image-upload-container {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .image-upload-area {
          border: 2px dashed #cbd5e1;
          border-radius: 12px;
          padding: 2.5rem 2rem;
          background: #f8fafc;
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .image-upload-area:hover {
          border-color: #3b82f6;
          background: #f0f9ff;
        }

        .file-input {
          display: none;
        }

        .upload-label {
          display: block;
          cursor: pointer;
        }

        .upload-content {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          gap: 1rem;
        }

        .upload-icon {
          width: 48px;
          height: 48px;
          color: #64748b;
        }

        .upload-text {
          color: #334155;
          font-weight: 600;
          font-size: 1.1rem;
          margin: 0;
        }

        .upload-hint {
          color: #94a3b8;
          font-size: 0.875rem;
          margin: 0;
        }

        .image-preview {
          background: white;
          border-radius: 12px;
          overflow: hidden;
          border: 1px solid #e2e8f0;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .preview-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1rem;
          background: #f8fafc;
          border-bottom: 1px solid #e2e8f0;
        }

        .preview-title {
          color: #334155;
          font-weight: 600;
          font-size: 0.95rem;
        }

        .remove-preview {
          background: #fecaca;
          color: #dc2626;
          border: none;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          font-size: 1.2rem;
          font-weight: bold;
          transition: all 0.2s ease;
        }

        .remove-preview:hover {
          background: #fca5a5;
          transform: scale(1.1);
        }

        .preview-image {
          width: 100%;
          height: 200px;
          object-fit: contain;
          padding: 1rem;
          background: white;
        }

        .form-actions {
          display: flex;
          justify-content: flex-end;
        }

        .submit-button {
          background: linear-gradient(135deg, #3b82f6, #2563eb);
          color: white;
          border: none;
          padding: 1rem 2.5rem;
          border-radius: 10px;
          font-size: 1.1rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          gap: 0.75rem;
          box-shadow: 0 4px 15px rgba(59, 130, 246, 0.3);
        }

        .submit-button:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
        }

        .submit-button:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        .button-spinner {
          width: 20px;
          height: 20px;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-top-color: white;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        .error-message {
          background: #fef2f2;
          color: #dc2626;
          padding: 1rem 1.5rem;
          border-radius: 10px;
          border: 1px solid #fecaca;
          display: flex;
          align-items: center;
          gap: 0.75rem;
          font-weight: 500;
        }

        .error-icon {
          width: 20px;
          height: 20px;
          flex-shrink: 0;
        }

        .list-section {
          background: white;
          border-radius: 16px;
          padding: 2.5rem;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          border: 1px solid #e2e8f0;
        }

        .list-section .section-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 1.5rem;
          margin-bottom: 2rem;
        }

        .header-content {
          flex: 1;
        }

        .search-box {
          position: relative;
          min-width: 300px;
        }

        .search-input {
          width: 100%;
          padding: 0.875rem 1rem 0.875rem 3rem;
          border: 2px solid #e2e8f0;
          border-radius: 10px;
          font-size: 1rem;
          transition: all 0.3s ease;
          background: #f8fafc;
          color: #334155;
        }

        .search-input:focus {
          outline: none;
          border-color: #3b82f6;
          background: white;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }

        .search-icon {
          position: absolute;
          right: 1rem;
          top: 50%;
          transform: translateY(-50%);
          width: 20px;
          height: 20px;
          color: #64748b;
        }

        .clear-search {
          position: absolute;
          left: 1rem;
          top: 50%;
          transform: translateY(-50%);
          background: none;
          border: none;
          color: #64748b;
          cursor: pointer;
          font-size: 1.5rem;
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          transition: all 0.2s ease;
        }

        .clear-search:hover {
          background: #e2e8f0;
          color: #475569;
        }

        .stats-bar {
          display: flex;
          gap: 1.5rem;
          margin-bottom: 2rem;
          padding-bottom: 1.5rem;
          border-bottom: 1px solid #e2e8f0;
        }

        .stat-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 1rem 1.5rem;
          background: #f8fafc;
          border-radius: 10px;
          min-width: 120px;
        }

        .stat-number {
          font-size: 2rem;
          font-weight: 700;
          color: #3b82f6;
          margin-bottom: 0.25rem;
        }

        .stat-label {
          color: #64748b;
          font-size: 0.875rem;
          font-weight: 500;
        }

        .empty-state {
          text-align: center;
          padding: 4rem 2rem;
        }

        .empty-icon {
          font-size: 4rem;
          margin-bottom: 1.5rem;
          opacity: 0.2;
        }

        .empty-title {
          color: #334155;
          font-size: 1.5rem;
          margin-bottom: 0.75rem;
          font-weight: 600;
        }

        .empty-description {
          color: #94a3b8;
          font-size: 1rem;
          max-width: 400px;
          margin: 0 auto;
          line-height: 1.6;
        }

        .academies-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
          gap: 1.5rem;
        }

        @media (max-width: 768px) {
          .academies-grid {
            grid-template-columns: 1fr;
          }
        }

        .academy-card {
          background: white;
          border: 2px solid #e2e8f0;
          border-radius: 12px;
          overflow: hidden;
          transition: all 0.3s ease;
        }

        .academy-card:hover {
          border-color: #3b82f6;
          transform: translateY(-4px);
          box-shadow: 0 8px 25px rgba(59, 130, 246, 0.15);
        }

        .card-header {
          display: flex;
          align-items: center;
          padding: 1.5rem;
          background: linear-gradient(135deg, #eff6ff, #dbeafe);
          gap: 1rem;
        }

        .academy-avatar {
          position: relative;
          flex-shrink: 0;
        }

        .avatar-image {
          width: 60px;
          height: 60px;
          border-radius: 12px;
          object-fit: cover;
          border: 3px solid white;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        }

        .avatar-placeholder {
          width: 60px;
          height: 60px;
          border-radius: 12px;
          background: linear-gradient(135deg, #3b82f6, #1d4ed8);
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
          font-weight: bold;
          border: 3px solid white;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        }

        .academy-info {
          flex: 1;
        }

        .academy-name {
          color: #1e293b;
          font-size: 1.25rem;
          font-weight: 700;
          margin: 0 0 0.25rem 0;
          line-height: 1.3;
        }

        .academy-email {
          color: #64748b;
          font-size: 0.875rem;
          margin: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .card-body {
          padding: 1.5rem;
        }

        .contact-info {
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
          margin-bottom: 1.5rem;
        }

        .contact-item {
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }

        .contact-icon {
          width: 18px;
          height: 18px;
          color: #64748b;
          flex-shrink: 0;
        }

        .contact-text {
          color: #475569;
          font-size: 0.9rem;
          flex: 1;
          line-height: 1.5;
        }

        .description-box {
          background: #f8fafc;
          border-radius: 8px;
          padding: 1rem;
          border: 1px solid #e2e8f0;
        }

        .description-text {
          color: #475569;
          font-size: 0.875rem;
          line-height: 1.6;
          margin: 0;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .card-footer {
          padding: 1rem 1.5rem;
          background: #f8fafc;
          border-top: 1px solid #e2e8f0;
        }

        .academy-id {
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .id-label {
          color: #64748b;
          font-size: 0.875rem;
          font-weight: 500;
        }

        .id-value {
          color: #334155;
          font-weight: 600;
          font-family: monospace;
          font-size: 0.875rem;
          background: white;
          padding: 0.25rem 0.5rem;
          border-radius: 4px;
          border: 1px solid #e2e8f0;
        }

        @media (max-width: 640px) {
          .academies-container {
            padding: 1rem;
          }

          .form-section,
          .list-section {
            padding: 1.5rem;
          }

          .page-title {
            font-size: 2rem;
          }

          .list-section .section-header {
            flex-direction: column;
            align-items: stretch;
          }

          .search-box {
            min-width: 100%;
          }

          .stats-bar {
            flex-direction: column;
            align-items: stretch;
          }

          .stat-item {
            width: 100%;
          }
        }

        /* تخصيصات للعرض المظلم */
        @media (prefers-color-scheme: dark) {
          .academies-container {
            background: #0f172a;
          }

          .page-title,
          .section-title,
          .academy-name {
            color: #f1f5f9;
          }

          .page-subtitle,
          .section-description,
          .form-label,
          .contact-text,
          .id-value {
            color: #cbd5e1;
          }

          .form-section,
          .list-section,
          .academy-card {
            background: #1e293b;
            border-color: #334155;
          }

          .form-input,
          .form-textarea,
          .search-input {
            background: #0f172a;
            border-color: #334155;
            color: #cbd5e1;
          }

          .form-input:focus,
          .form-textarea:focus,
          .search-input:focus {
            background: #0f172a;
            border-color: #3b82f6;
          }

          .image-upload-area {
            background: #0f172a;
            border-color: #334155;
          }

          .description-box,
          .card-footer {
            background: #0f172a;
            border-color: #334155;
          }

          .stat-item {
            background: #0f172a;
          }

          .error-message {
            background: #7f1d1d;
            border-color: #991b1b;
            color: #fecaca;
          }

          .avatar-placeholder {
            background: linear-gradient(135deg, #1e40af, #1e3a8a);
          }
        }
      `}</style>
    </div>
  );
}